document.addEventListener('DOMContentLoaded', () => {
  // =============================
  // 定数定義
  // =============================
  const BASE_W = 900;
  const BASE_H = 1100;
  const PRINT_W = 350;
  const PRINT_H = 390;
  const ROTATION_SNAP = 15;
  const MIN_SCALE = 0.1;
  const MAX_SCALE = 0.5;

  // #669 印刷範囲に追加できる素材（画像・ロゴ・図形）の合計上限。
  // セクション設定 max_materials（sections/tshirt-designer.liquid の data-max-materials）から受け取る。
  const MAX_MATERIALS =
    parseInt(document.getElementById('tshirt-designer')?.dataset.maxMaterials, 10) || 30;

  // 印刷エリア拡大表示（引き⇄拡大トグル）
  const ZOOM_PADDING = 1.2;   // 拡大時に印刷エリア周囲をどれだけ見せるか（1.0=ぴったり）
  let zoomMode = 'fit';       // 'fit'=Tシャツ全体 / 'zoom'=印刷エリア拡大
  let currentShapeColor = '#555555'; // 図形の塗り色（色スウォッチで変更）

  // #662 戻る/進む（undo/redo）。デザイン素材の状態のみを対象にした軽量スナップショット。
  // フルJSON直列化は行わず、fabricオブジェクトの参照を保持したまま状態を記録・復元する
  // （削除しても参照は保持＝undoで同じインスタンスを戻すだけ。クリップ/画像/ロゴ内部色は自動的に保たれる）。
  // 印刷範囲の形変更・Tシャツ・印刷枠・ガイドは対象外（触れない）。
  let history = [];
  let histIndex = -1;
  let restoring = false;      // 復元中フラグ。復元起因のイベントで再スナップショットしないためのガード
  const HISTORY_MAX = 60;

  // スケール制限用キャッシュ
  let lastValidScale = {};

  // =============================
  // DOM要素取得
  // =============================
  const canvasEl = document.getElementById('tshirt-canvas');
  const toolbar = document.querySelector('.designer-toolbar');
  const tabs = document.querySelectorAll('.designer-tab-btn');
  const imageBtns = document.querySelectorAll('.designer-image-btn');
  const shapeBtns = document.querySelectorAll('.designer-shape-btn');
  const colorInput = document.querySelector('.designer-color-input');
  const colorToggle = document.getElementById('color-toggle');
  const colorToggleSwatch = colorToggle ? colorToggle.querySelector('.color-toggle__swatch') : null;
  const toolBarHeight = document.querySelector('.tool-bar')?.offsetHeight || 0;
  const layerToggle =document.getElementById('layer-toggle');
  const zoomToggle = document.getElementById('zoom-toggle');
  const layerPanel = document.getElementById('layer-panel');
  const layerList = document.getElementById('layer-list');
  const lockIcon = document.querySelector('#icon-lock-template').innerHTML;
  const trashIcon = document.querySelector('#icon-trash-template').innerHTML;
  const dragIcon = document.querySelector('#icon-drag-template').innerHTML;

  if (!canvasEl || !toolbar) {
    console.error('必須要素が見つかりません');
    return;
  }

  let sortableInstance = null;

function initLayerSorting() {

  if (!layerList) return;

  if (sortableInstance) {
    sortableInstance.destroy();
  }

  sortableInstance = new Sortable(layerList, {
    animation: 150,

    // #669 掴み手アイコンからのみドラッグを開始する。行の他の場所は一覧のスクロールに使えるようになり、
    // 素材が多いときにスクロールしようとして重ね順が変わってしまうのを防ぐ。
    handle: '.layer-drag-handle',

    filter: '.layer-lock, .layer-delete',
    preventOnFilter: false,

    onEnd() {
      updateCanvasLayerOrder();
      pushHistory(); // #662 重なり順の変更を履歴へ
    }
  });

}

function updateCanvasLayerOrder() {

  const items = [...layerList.children];

  const designObjects = canvas
    .getObjects()
    .filter(obj =>
      obj !== printArea &&
      obj.__isDesignPart
    );

  const objectMap = {};

  designObjects.forEach(obj => {
    objectMap[obj.__layerId] = obj;
  });

  items.reverse().forEach((item, index) => {

    const obj = objectMap[item.dataset.objectId];

    if (!obj) return;

    canvas.moveTo(obj, index + 1);

  });

  canvas.requestRenderAll();
}

// =============================
// レイヤー
// =============================

// #661 同名素材の区別用。素材の作成順（安定した連番）。並べ替えしても番号が保たれる。
let layerSeq = 0;

layerToggle?.addEventListener('click', () => {
  layerPanel.classList.toggle('active');
});

function renderLayerPanel() {

  if (!layerList) return;

  // #669 この関数は素材選択・ロック・削除・undoなどでも呼ばれて一覧を作り直すため、
  // 退避しておかないと操作のたびにスクロール位置が先頭へ戻ってしまう。
  const prevScrollTop = layerList.scrollTop;

  layerList.innerHTML = '';

  const activeObj = canvas.getActiveObject();

  const designParts = canvas
    .getObjects()
    .filter(obj =>
      obj !== printArea &&
      obj.__isDesignPart
    );

  // #661 同名素材が2つ以上あるときだけ、区別用の番号(1..n)を振る。
  // 番号は作成順(__seq)で安定して割り当て、並べ替えしても素材ごとの番号は変わらない。
  const nameGroups = {};
  designParts.forEach(obj => {
    const key = obj.materialName || '素材';
    (nameGroups[key] = nameGroups[key] || []).push(obj);
  });
  Object.values(nameGroups).forEach(list => {
    if (list.length > 1) {
      list.sort((a, b) => (a.__seq || 0) - (b.__seq || 0));
      list.forEach((obj, i) => { obj.__dupNumber = i + 1; });
    } else {
      list[0].__dupNumber = 0;
    }
  });

  const layers = designParts.slice().reverse();

  layers.forEach(obj => {

    const item = document.createElement('button');
    item.className = 'layer-item';
    item.dataset.objectId = obj.__layerId;

    if (activeObj === obj) {
      item.classList.add('active');
    }

    const dragHandle = document.createElement('div');
    dragHandle.className = 'layer-drag-handle';
    dragHandle.innerHTML = dragIcon;

    let thumb;
    if (obj.imageUrl) {
      thumb = document.createElement('img');
      thumb.className = 'layer-thumb';
      thumb.src = obj.imageUrl;
      thumb.draggable = false;
    } else {
      // 図形レイヤー：画像がないので種別アイコンを表示
      thumb = document.createElement('div');
      thumb.className = 'layer-thumb layer-thumb--shape';
      const fc = obj.fill || '#555';
      const shapeSvg = {
        circle: '<svg viewBox="0 0 40 40"><circle cx="20" cy="20" r="14" fill="' + fc + '"/></svg>',
        triangle: '<svg viewBox="0 0 40 40"><polygon points="20,7 34,33 6,33" fill="' + fc + '"/></svg>',
        rect: '<svg viewBox="0 0 40 40"><rect x="8" y="8" width="24" height="24" fill="' + fc + '"/></svg>'
      };
      thumb.innerHTML = shapeSvg[obj.shapeType] || shapeSvg.rect;
    }

    const nameBtn = document.createElement('h4');
    nameBtn.className = 'layer-name';
    nameBtn.textContent =
      obj.materialName || '素材';

    // #661 同名素材の区別用の番号バッジ（名前が省略されても消えないよう別要素にする）
    let numBadge = null;
    if (obj.__dupNumber) {
      numBadge = document.createElement('span');
      numBadge.className = 'layer-num';
      numBadge.textContent = obj.__dupNumber;
    }

    const lockBtn = document.createElement('button');
    lockBtn.className = 'layer-lock';

    const deleteBtn = document.createElement('button');
    deleteBtn.className = 'layer-delete';

    const isLocked = obj.lockMovementX;

    lockBtn.innerHTML = lockIcon;
    if (isLocked) {
      lockBtn.classList.add('is-locked');
    } else {
      lockBtn.classList.remove('is-locked');
    }

    deleteBtn.innerHTML = trashIcon;

    item.append(dragHandle, thumb, nameBtn);
    if (numBadge) item.append(numBadge);
    item.append(lockBtn, deleteBtn);

    layerList.appendChild(item);

    // 素材選択
    nameBtn.addEventListener('click', () => {

      if (!obj.selectable) return;

      canvas.setActiveObject(obj);
      canvas.requestRenderAll();

      renderLayerPanel();

    });

    // ロック
    lockBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const locked = obj.lockMovementX;

      if (locked) {

        obj.set({
          lockMovementX: false,
          lockMovementY: false,
          lockRotation: false,
          lockScalingX: false,
          lockScalingY: false,

          selectable: true,
          evented: true,

          hasControls: true
        });

      } else {

        obj.set({
          lockMovementX: true,
          lockMovementY: true,
          lockRotation: true,
          lockScalingX: true,
          lockScalingY: true,

          selectable: false,
          evented: false,

          hasControls: false
        });

        canvas.discardActiveObject();

      }

      canvas.requestRenderAll();
      renderLayerPanel();
      pushHistory(); // #662 ロック/解除を履歴へ

    });

    // 削除
    deleteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      canvas.remove(obj);

      if (canvas.getActiveObject() === obj) {
        canvas.discardActiveObject();
      }

      canvas.requestRenderAll();
      renderLayerPanel();
      pushHistory(); // #662 削除を履歴へ（objは参照保持＝undoで戻せる）

    });

  });

  // Sortable再初期化
  initLayerSorting();

  // #669 作り直した一覧のスクロール位置を元に戻す（素材が減った場合はブラウザ側で最大値へ丸められる）
  layerList.scrollTop = prevScrollTop;

}

  // =============================
  // Canvas 初期化
  // =============================
  const canvas = new fabric.Canvas(canvasEl, {
    width: BASE_W,
    height: BASE_H,
    backgroundColor: '#fff',
    preserveObjectStacking: true,
    selection: false, // 空白ドラッグでの範囲（複数）選択を無効化。個別選択は可能。
    allowTouchScrolling: false,
    enableRetinaScaling: true
  });

  canvas.on('selection:created', renderLayerPanel);
  canvas.on('selection:updated', renderLayerPanel);
  canvas.on('selection:created', updateColorToggle);
  canvas.on('selection:updated', updateColorToggle);
  canvas.on('selection:cleared', renderLayerPanel);
  canvas.on('selection:cleared', updateColorToggle);
  canvas.on('object:removed', renderLayerPanel);

  // =============================
  // レスポンシブリサイズ
  // =============================
  function resizeCanvas() {
    const viewportW = window.innerWidth;
    const viewportH = window.innerHeight - toolBarHeight;

    const canvasRatio = BASE_W / BASE_H;
    const viewportRatio = viewportW / viewportH;

    let scale;
    if (viewportRatio > canvasRatio) {
      scale = (viewportH * 0.95) / BASE_H;
    } else {
      scale = (viewportW * 0.85) / BASE_W;
    }

    scale = Math.min(scale, 1);

    // 表示領域（canvas要素の実サイズ）は常に「全体フィット」基準。
    // 拡大は viewportTransform だけで行い、外側レイアウトは動かさない。
    canvas.setWidth(BASE_W * scale);
    canvas.setHeight(BASE_H * scale);
    applyZoomMode(scale);
    updateLayerPanelMaxHeight();
  }

  // #669 レイヤーパネルの最大高さを「画面高 - パネル上端 - ツールバー高 - 余白」で算出する。
  // 素材が多いときに一覧をできるだけ広く見せつつ、下部固定の .tool-bar にかぶらないようにする。
  // ツールバーは素材パネルの開閉で高さが変わるため、定数ではなく都度実寸を取り直す。
  const LAYER_PANEL_TOP = 80; // .designer-layers(top:10px) + .layer-panel(top:60px + margin-top:1rem)
  const LAYER_PANEL_GAP = 10; // ツールバーとの余白
  // 下限は「見出し＋1行」が見える程度に留める。これを大きくすると、画面が低いとき
  // （スマホ横向き＝高さ375px前後）にパネルがツールバーへ被さってタブが押せなくなる。
  const LAYER_PANEL_MIN_H = 100;
  function updateLayerPanelMaxHeight() {
    if (!layerPanel) return;
    const barH = document.querySelector('.tool-bar')?.offsetHeight || toolBarHeight;
    const maxH = Math.max(LAYER_PANEL_MIN_H, window.innerHeight - LAYER_PANEL_TOP - barH - LAYER_PANEL_GAP);
    layerPanel.style.setProperty('--layer-panel-max-h', maxH + 'px');
  }

  // 現状 .tool-bar の高さはタブ1行＋ .designer-toolbar（height:100px）で固定だが、
  // 構成が変わって高さが動いてもパネルがツールバーへかぶらないよう変化を監視する。
  // （max-height を変えるだけで .tool-bar のサイズには影響しないのでループしない）
  if (typeof ResizeObserver !== 'undefined') {
    const toolBarEl = document.querySelector('.tool-bar');
    if (toolBarEl) new ResizeObserver(updateLayerPanelMaxHeight).observe(toolBarEl);
  }

  // 現在の zoomMode に応じてビューポート変換を適用する。
  // fit  … Tシャツ全体を表示（pan なし）
  // zoom … 印刷エリア中心を拡大表示（作業したまま拡大できる）
  function applyZoomMode(fitScale) {
    if (typeof fitScale !== 'number') {
      fitScale = canvas.getWidth() / BASE_W; // 引数省略時は現DOMサイズから逆算
    }

    if (zoomMode === 'zoom') {
      const domW = canvas.getWidth();
      const domH = canvas.getHeight();
      const z = Math.min(domW / (PRINT_W * ZOOM_PADDING), domH / (PRINT_H * ZOOM_PADDING));
      const cx = BASE_W / 2;
      const cy = BASE_H / 2;
      const tx = domW / 2 - z * cx;
      const ty = domH / 2 - z * cy;
      canvas.setViewportTransform([z, 0, 0, z, tx, ty]);
    } else {
      canvas.setViewportTransform([fitScale, 0, 0, fitScale, 0, 0]);
    }

    canvas.requestRenderAll();
  }

  // 拡大／引きトグルボタン
  if (zoomToggle) {
    zoomToggle.addEventListener('click', () => {
      zoomMode = (zoomMode === 'zoom') ? 'fit' : 'zoom';
      zoomToggle.classList.toggle('is-zoomed', zoomMode === 'zoom');
      zoomToggle.setAttribute('aria-pressed', zoomMode === 'zoom' ? 'true' : 'false');
      zoomToggle.setAttribute('aria-label', zoomMode === 'zoom' ? '全体表示に戻す' : '印刷エリアを拡大表示');
      applyZoomMode();
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeCanvas, 100);
  });
  resizeCanvas();

  // =============================
  // 表示解禁（reveal）
  // #666 リロード時のチラつき対策。固定タイマーではなく「TシャツSVG読込完了」と
  // 「初期カテゴリフィルタ完了」の両方が揃ってから #tshirt-designer を表示する。
  // これで「白キャンバス→Tシャツ遅延出現」「全素材が一瞬並ぶ→1カテゴリに縮む」を防ぐ。
  // =============================
  const designerSection = document.getElementById('tshirt-designer');
  let svgReady = false;
  let initialFilterReady = false;
  let imagesReady = false; // 初期表示カテゴリの素材サムネ読込完了
  let fontsReady = false;  // Webフォント読込完了（タブ等の文字のチラつき防止）
  let revealed = false;
  function revealDesigner() {
    if (revealed) return;
    revealed = true;
    resizeCanvas();
    if (designerSection) designerSection.classList.add('designer-ready');
  }
  function maybeReveal() {
    if (svgReady && initialFilterReady && imagesReady && fontsReady) revealDesigner();
  }
  // #666 初期カテゴリの素材サムネ読込完了を待つ（解禁後のポップイン防止）。
  // 初期フィルタ後、display:none 以外＝アクティブカテゴリの img のみ対象。失敗しても解禁は止めない。
  function waitForInitialThumbnails() {
    const visibleImgs = Array.from(document.querySelectorAll('.designer-image-btn'))
      .filter(btn => btn.style.display !== 'none')
      .map(btn => btn.querySelector('img'))
      .filter(Boolean);
    if (visibleImgs.length === 0) { imagesReady = true; maybeReveal(); return; }
    let remaining = visibleImgs.length;
    const onOne = () => { remaining--; if (remaining <= 0) { imagesReady = true; maybeReveal(); } };
    visibleImgs.forEach(img => {
      img.loading = 'eager'; // 遅延読込を解除して即取得
      // complete が true なら読込は成功・失敗どちらでも完了済み。
      // 失敗済み（naturalWidth === 0）にリスナーを付けても load/error は再発火せず、
      // imagesReady が立たないまま保険タイマーまで待つことになるため、ここで完了扱いにする。
      if (img.complete) { onOne(); }
      else {
        img.addEventListener('load', onOne, { once: true });
        img.addEventListener('error', onOne, { once: true });
      }
    });
  }
  // #666 Webフォント読込完了を待つ（タブ等の文字のFOUT/再フローを防ぐ）
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => { fontsReady = true; maybeReveal(); });
  } else {
    fontsReady = true;
  }
  // 保険：読込失敗などでフラグが揃わなくても最大2秒で強制表示（白画面固着を防ぐ）
  setTimeout(revealDesigner, 2000);
  // 保険：window load 後にも表示を確定させる（既に表示済みなら無害）
  window.addEventListener('load', () => setTimeout(revealDesigner, 50));

  // =============================
  // Tシャツ SVG 読み込み
  // =============================
  if (window.TSHIRT_SVG_URL) {
    fabric.loadSVGFromURL(window.TSHIRT_SVG_URL, (objects, options) => {
      const shirt = fabric.util.groupSVGElements(objects, options);
      // #661 印刷枠（中央固定・サイズ不変）に対して、TシャツSVG側で相対関係を調整する。
      // 印刷/クリップ/書き出し/範囲エディタは中央固定・PRINT_W/H基準のまま（出力は不変）。
      //  - scaleを下げる  → 枠がTシャツに対して相対的に大きく見える
      //  - topを下げる    → 枠がTシャツに対して相対的に上に見える
      shirt.set({
        selectable: false,
        evented: false,
        originX: 'center',
        originY: 'center',
        left: BASE_W / 2,
        top: BASE_H / 2 + 50, // 550 → 600（下げるほど枠は相対的に上へ）
        scaleX: 0.82,         // 1.1 → 0.82（小さいほど枠は相対的に大きく）
        scaleY: 0.82,
        __isTshirt: true
      });
      canvas.add(shirt);
      shirt.sendToBack();
      canvas.requestRenderAll();
      console.log('✅ Tシャツテンプレート読み込み完了');
      svgReady = true;
      maybeReveal();
    }, null, { crossOrigin: 'anonymous' });
  } else {
    console.warn('⚠️ TSHIRT_SVG_URL が設定されていません');
    // 下地SVGが無い場合でも表示解禁できるようにする
    svgReady = true;
    maybeReveal();
  }

  // =============================
  // 印刷エリア枠
  // =============================
  let printArea = new fabric.Rect({
    left: BASE_W / 2,
    top: BASE_H / 2,
    originX: 'center',
    originY: 'center',
    width: PRINT_W,
    height: PRINT_H,
    fill: 'transparent',
    stroke: '#000',
    strokeWidth: 2,
    strokeDashArray: [10, 8],
    selectable: false,
    evented: false
  });
  canvas.add(printArea);

  // =============================
  // クリップマスク
  // =============================
  let mask = new fabric.Rect({
    originX: 'center',
    originY: 'center',
    left: BASE_W / 2,
    top: BASE_H / 2,
    width: PRINT_W,
    height: PRINT_H,
    absolutePositioned: true
  });

  // =============================
  // 印刷範囲の形（全体／丸／三角）
  // =============================
  let printShapeType = 'full';
  let printShapeConfirmed = false;
  let pendingPrintShape = 'full';
  // カスタム＝お客様が置いた図形（印刷ウィンドウ）の内側だけを印刷範囲にするモード
  let customMode = false;

  function makePrintShape(type, extra) {
    const base = {
      left: BASE_W / 2,
      top: BASE_H / 2,
      originX: 'center',
      originY: 'center'
    };
    if (type === 'circle') {
      return new fabric.Circle(Object.assign({}, base, extra, { radius: Math.min(PRINT_W, PRINT_H) / 2 }));
    }
    if (type === 'triangle') {
      return new fabric.Triangle(Object.assign({}, base, extra, { width: PRINT_W, height: PRINT_H }));
    }
    return new fabric.Rect(Object.assign({}, base, extra, { width: PRINT_W, height: PRINT_H }));
  }

  // プリセット（全体／丸／三角）の点線枠・クリップを差し替える
  function setPrintShape(type) {
    printShapeType = type;
    customMode = false;

    // カスタム用ガイドが残っていれば消す
    canvas.getObjects().filter(o => o.__isRegionGuide).forEach(o => canvas.remove(o));

    canvas.remove(printArea);
    printArea = makePrintShape(type, {
      fill: 'transparent',
      stroke: '#000',
      strokeWidth: 2,
      strokeDashArray: [10, 8],
      selectable: false,
      evented: false
    });
    canvas.add(printArea);
    // 枠は最背面（TシャツSVG）の1つ上に置き、デザインパーツの下に敷く
    canvas.sendToBack(printArea);
    const shirtObj = canvas.getObjects().find(o => o.__isTshirt);
    if (shirtObj) canvas.sendToBack(shirtObj);

    mask = makePrintShape(type, { absolutePositioned: true });
    canvas.getObjects().forEach(obj => {
      if (obj.__isDesignPart) obj.clipPath = mask;
    });

    canvas.requestRenderAll();
  }

  // ---- カスタム：範囲エディタで作った印刷ウィンドウ（メインキャンバス座標で受け取る）----
  // 各 def: { type, cx, cy, angle, scaleX, scaleY, radius（丸）, w/h（三角・四角） }
  let customWindows = [];

  function makeWindowShape(w) {
    const opts = {
      originX: 'center', originY: 'center',
      left: w.cx, top: w.cy,
      angle: w.angle || 0,
      scaleX: w.scaleX || 1,
      scaleY: w.scaleY || 1
    };
    if (w.type === 'circle') return new fabric.Circle(Object.assign(opts, { radius: w.radius }));
    if (w.type === 'triangle') return new fabric.Triangle(Object.assign(opts, { width: w.w, height: w.h }));
    return new fabric.Rect(Object.assign(opts, { width: w.w, height: w.h }));
  }

  // 全ウィンドウの合計（和）を、さらにデフォルト長方形と交差させたものをクリップ範囲にする。
  // ＝はみ出した部分は印刷されない（長方形の中だけ）。
  function buildCustomClip() {
    if (!customWindows.length) return null;
    let clip;
    if (customWindows.length === 1) {
      clip = makeWindowShape(customWindows[0]);
    } else {
      clip = new fabric.Group(customWindows.map(makeWindowShape));
    }
    clip.absolutePositioned = true;
    // 長方形との交差（入れ子クリップ）で、長方形の外は切り落とす
    clip.clipPath = makePrintShape('full', { absolutePositioned: true });
    return clip;
  }

  // ウィンドウ index の枠線のうち「長方形の中」かつ「他のウィンドウの外側」だけを表示するクリップ。
  // 全ウィンドウ分を重ねると、重なりの内側の線が消え、外周の1本だけになる。
  function makeGuideOuterClip(index) {
    const rectClip = makePrintShape('full', { absolutePositioned: true });
    const others = customWindows.filter((_, i) => i !== index).map(makeWindowShape);
    if (others.length) {
      const othersUnion = new fabric.Group(others, { absolutePositioned: true });
      othersUnion.inverted = true;     // 他ウィンドウの「外側」だけを通す
      rectClip.clipPath = othersUnion; // 長方形 ∩ （他ウィンドウの外側）
    }
    return rectClip;
  }

  // 範囲エディタの「作成する」から呼ばれ、カスタムの枠・ガイド・クリップを確定する。
  // 各ウィンドウは範囲エディタでデフォルト長方形内に制限済み＝印刷は長方形内のみ。
  function applyCustomWindows(defs) {
    printShapeType = 'custom';
    customMode = true;
    customWindows = defs || [];

    // 外枠は常に全体（長方形）＝ここだけが印刷可能な最大範囲
    canvas.remove(printArea);
    printArea = makePrintShape('full', {
      fill: 'transparent',
      stroke: '#000',
      strokeWidth: 2,
      strokeDashArray: [10, 8],
      selectable: false,
      evented: false
    });
    canvas.add(printArea);
    canvas.sendToBack(printArea);
    const shirtObj = canvas.getObjects().find(o => o.__isTshirt);
    if (shirtObj) canvas.sendToBack(shirtObj);

    // 印刷ウィンドウの目印（青点線・編集不可・印刷されない）。はみ出しは長方形でクリップして表示しない。
    canvas.getObjects().filter(o => o.__isRegionGuide).forEach(o => canvas.remove(o));
    customWindows.forEach((w, i) => {
      const g = makeWindowShape(w);
      g.set({
        fill: 'transparent',            // 塗りなし＝枠線のみ
        stroke: '#3b82f6',
        strokeWidth: 2,
        strokeDashArray: [6, 4],
        strokeUniform: true,            // 拡大縮小しても点線の太さを一定に（範囲エディタと共通）
        selectable: false,
        evented: false,
        // 長方形の中かつ他ウィンドウの外側だけ表示＝重なりの内側線を消し外周のみに
        clipPath: makeGuideOuterClip(i)
      });
      g.__isRegionGuide = true;
      canvas.add(g);
    });

    // 既存デザインパーツをウィンドウ合計でクリップ
    canvas.getObjects().forEach(obj => {
      if (obj.__isDesignPart) { obj.clipPath = buildCustomClip(); obj.dirty = true; }
    });

    canvas.requestRenderAll();
  }

  // マニュアルを閉じた後に一度だけ表示する形選択モーダル（DOMはliquid側、無ければ何もしない）
  const printShapeModal = document.getElementById('print-shape-modal');
  const printShapeBtns = document.querySelectorAll('.print-shape-btn');
  const printShapeConfirmBtn = document.querySelector('.print-shape-confirm');

  printShapeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      printShapeBtns.forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      pendingPrintShape = btn.dataset.shape || 'full';
    });
  });

  // #661 汎用の確認モーダル（重要操作前に警告を出す。DOMはliquid側 #designer-confirm-modal）
  const confirmModal = document.getElementById('designer-confirm-modal');
  const confirmModalMsg = document.getElementById('designer-confirm-message');
  const confirmModalOkBtn = document.getElementById('designer-confirm-ok');
  const confirmModalCancelBtn = document.getElementById('designer-confirm-cancel');
  let confirmModalOnOk = null;

  function showConfirmDialog(message, onOk, opts) {
    opts = opts || {};
    if (!confirmModal) { // モーダルDOMが無い環境では素のconfirm/alertで代替
      // #669 hideCancel は「知らせるだけ」の用途。選択肢が無いので alert で代替する。
      if (opts.hideCancel) {
        window.alert(message);
        if (typeof onOk === 'function') onOk();
        return;
      }
      if (window.confirm(message)) { if (typeof onOk === 'function') onOk(); }
      return;
    }
    if (confirmModalMsg) confirmModalMsg.textContent = message;
    if (confirmModalOkBtn) confirmModalOkBtn.textContent = opts.okLabel || 'OK';
    if (confirmModalCancelBtn) {
      confirmModalCancelBtn.textContent = opts.cancelLabel || 'キャンセル';
      // #669 知らせるだけの用途では選ぶものが無いのでキャンセルを出さない
      confirmModalCancelBtn.style.display = opts.hideCancel ? 'none' : '';
    }
    confirmModalOnOk = (typeof onOk === 'function') ? onOk : null;
    confirmModal.classList.add('active');
  }
  function hideConfirmDialog() {
    if (confirmModal) confirmModal.classList.remove('active');
    confirmModalOnOk = null;
  }
  if (confirmModalOkBtn) {
    confirmModalOkBtn.addEventListener('click', () => {
      const cb = confirmModalOnOk;
      hideConfirmDialog();
      if (cb) cb();
    });
  }
  if (confirmModalCancelBtn) {
    confirmModalCancelBtn.addEventListener('click', hideConfirmDialog);
  }

  if (printShapeConfirmBtn) {
    printShapeConfirmBtn.addEventListener('click', () => {
      if (pendingPrintShape === 'custom') {
        // カスタムは範囲エディタ（別画面）へ。確定は範囲エディタの「作成する」で行う。
        // 前回もカスタムなら既存の範囲を復元して調整できるようにする。
        showRangePane();
        initRangeEditor(printShapeType === 'custom');
      } else {
        const applyPreset = () => {
          setPrintShape(pendingPrintShape);
          printShapeConfirmed = true;
          if (printShapeModal) printShapeModal.classList.remove('active');
        };
        // #661 カスタム印刷範囲を作っている状態でプリセット（全体/丸/三角）へ変えると
        // カスタム範囲は削除される。元に戻せないため警告を出す。
        if (printShapeType === 'custom' && customWindows.length > 0) {
          showConfirmDialog(
            'カスタムで作成した印刷範囲は削除されます。\nこの操作は元に戻せませんが、続けますか？',
            applyPreset,
            { okLabel: '変更する', cancelLabel: 'やめる' }
          );
        } else {
          applyPreset();
        }
      }
    });
  }

  function showPrintShapeModalOnce() {
    if (printShapeConfirmed) return;
    if (typeof showSelectPane === 'function') showSelectPane(); // 常に形選択から
    if (printShapeModal) printShapeModal.classList.add('active');
  }

  // 印刷可能枠の再調整：いつでも形選択モーダルを開く（現在の形を選択状態にして表示）
  function openPrintShapeModal() {
    if (typeof showSelectPane === 'function') showSelectPane();
    pendingPrintShape = printShapeType || 'full';
    printShapeBtns.forEach(b => b.classList.toggle('is-selected', b.dataset.shape === pendingPrintShape));
    if (printShapeModal) printShapeModal.classList.add('active');
  }

  const printRangeEditBtn = document.getElementById('print-range-edit');
  if (printRangeEditBtn) {
    printRangeEditBtn.addEventListener('click', openPrintShapeModal);
  }

  // =============================
  // #669 素材数の上限（画像・ロゴ・図形の合計）
  // =============================

  // 現在キャンバスに置かれているデザイン素材の数。レイヤー一覧と同じ条件で数える。
  function countDesignParts() {
    return canvas
      .getObjects()
      .filter(obj => obj !== printArea && obj.__isDesignPart)
      .length;
  }

  // これ以上追加できるかを判定する。上限に達している場合はその場で知らせて false を返す。
  // notify に false を渡すと知らせずに判定だけ行う（非同期読み込み後の最終確認用）。
  function canAddMaterial(notify) {
    if (countDesignParts() < MAX_MATERIALS) return true;
    if (notify !== false) {
      showConfirmDialog(
        `素材は合計${MAX_MATERIALS}個までです。\nこれ以上追加するには、使わない素材を削除してください。`,
        null,
        { okLabel: '閉じる', hideCancel: true }
      );
    }
    return false;
  }

  // =============================
  // 画像追加機能
  // =============================
  imageBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const url = btn.dataset.imageUrl;
      const materialName = btn.dataset.materialName || '素材';
      const category = btn.dataset.category || '';
      if (!url) {
        console.error('画像URLが設定されていません', btn);
        return;
      }

      // #669 上限に達していたら読み込む前に止める
      if (!canAddMaterial()) return;

      console.log('画像追加:', url);

      // カテゴリ「ロゴ」のSVGはベクターとして読み込み、色変更できるようにする（単色前提）。
      // PNG/WebP等のラスター画像のロゴは通常画像として追加する（色変更ボタンは非表示）。
      const isLogoCategory = (category === 'ロゴ');
      if (isLogoCategory && isSvgUrl(url)) {
        addLogoSVG(url, materialName);
        return;
      }

      fabric.Image.fromURL(url, (img) => {
        img.materialName = materialName;
        img.__layerId = crypto.randomUUID();
        img.__seq = ++layerSeq;
        img.imageUrl = url;
        img.__isDesignPart = true;
        img.__isShape = false;

        // 背景カテゴリの素材だけ、印刷エリア（PRINT_W×PRINT_H）を覆えるサイズまで拡大可能にする。
        // 通常素材は従来どおり MAX_SCALE が上限。
        const isBackground = (category === '背景');
        img.isBackground = isBackground;
        if (isBackground && img.width && img.height) {
          const coverScale = Math.max(PRINT_W / img.width, PRINT_H / img.height);
          img.maxScale = coverScale * 1.3; // 覆う＋位置調整の余裕
        } else if (isLogoCategory && img.width && img.height) {
          // ラスターロゴの拡大上限はSVGロゴと同じ（印刷エリアを覆える程度）にそろえる
          img.maxScale = Math.max(PRINT_W / img.width, PRINT_H / img.height) * 1.5;
        } else {
          img.maxScale = MAX_SCALE;
        }
        img.set({
          left: BASE_W / 2,
          top: BASE_H / 2,
          originX: 'center',
          originY: 'center',
          clipPath: mask,
          cornerStyle: 'circle',
          transparentCorners: false,
          cornerColor: '#999',
          cornerStrokeColor: '#fff',
          borderColor: '#ccc',
          borderOpacityWhenMoving: 0.5,
          cornerSize: 12,
          touchCornerSize: 24,
          hasRotatingPoint: true,
          padding: 0,
          lockScalingFlip: true,
          lockUniScaling: false
        });
        
        img.setControlsVisibility({
          mt: false,
          mb: false,
          ml: false,
          mr: false,
          tl: true,
          tr: true,
          bl: true,
          br: true,
          mtr: true
        });
        
        img.scaleToWidth(180);
        // 横長ロゴは配置時のスケールが MIN_SCALE を下回り得るため、SVGロゴと同様に下限を個別設定する
        if (isLogoCategory) img.minScale = Math.min(MIN_SCALE, img.scaleX * 0.3);
        console.log(
          '追加直後',
          img.scaleX,
          img.getScaledWidth(),
          img.getScaledHeight()
        );
        
        // #669 読み込み中に他の素材が増えて上限に達した場合は追加しない（連続タップ対策）
        if (!canAddMaterial(false)) return;

        canvas.add(img);
        // カスタムモードでは印刷ウィンドウ（複数の合計）でクリップする
        if (customMode) img.clipPath = buildCustomClip();
        renderLayerPanel();
        canvas.setActiveObject(img);
        canvas.requestRenderAll();
        pushHistory(); // #662 素材追加を履歴へ

        console.log('✅ 画像追加完了');
      }, { crossOrigin: 'anonymous' });
    });
  });

  // 素材URLがSVGかどうかを拡張子で判定する（?width= などのクエリは除いて判定）
  function isSvgUrl(url) {
    try {
      const abs = url.indexOf('//') === 0 ? location.protocol + url : url;
      return /\.svg$/i.test(new URL(abs, location.href).pathname);
    } catch (e) {
      return /\.svg(\?|$)/i.test(url);
    }
  }

  // Shopify は SVG に width/height 変換を付けるとPNGへラスタライズしてしまう。
  // SVGとして解析するため、width/height クエリを取り除いた生のSVG URLを返す。
  function svgSourceUrl(url) {
    try {
      const abs = url.indexOf('//') === 0 ? location.protocol + url : url;
      const u = new URL(abs, location.href);
      u.searchParams.delete('width');
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) {
      return url.replace(/([?&])(?:width|height)=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/([?&])&+/g, '$1');
    }
  }

  // ロゴ（単色SVG）をベクターとして追加。色変更できるよう __isShape 扱いにする。
  function addLogoSVG(url, materialName) {
    fabric.loadSVGFromURL(svgSourceUrl(url), (objects, options) => {
      if (!objects || !objects.length) {
        console.error('ロゴSVGの読み込みに失敗しました（SVGのURL/CORSを確認）:', url);
        return;
      }
      const logo = fabric.util.groupSVGElements(objects, options);
      logo.materialName = materialName || 'ロゴ';
      logo.__layerId = crypto.randomUUID();
      logo.__seq = ++layerSeq;
      logo.imageUrl = url;      // レイヤーのサムネ表示用
      logo.__isDesignPart = true;
      logo.__isShape = true;    // 色変更ボタンの対象にする
      logo.__isLogo = true;     // 色変更は内部の各パスへ適用する
      logo.shapeType = 'logo';
      logo.set({
        left: BASE_W / 2,
        top: BASE_H / 2,
        originX: 'center',
        originY: 'center',
        clipPath: customMode ? buildCustomClip() : mask,
        cornerStyle: 'circle',
        transparentCorners: false,
        cornerColor: '#999',
        cornerStrokeColor: '#fff',
        borderColor: '#ccc',
        borderOpacityWhenMoving: 0.5,
        cornerSize: 12,
        touchCornerSize: 24,
        hasRotatingPoint: true,
        padding: 0,
        lockScalingFlip: true,
        lockUniScaling: false
      });
      logo.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false, tl: true, tr: true, bl: true, br: true, mtr: true });
      logo.scaleToWidth(180);
      // 横長ロゴは配置時のスケールが小さく MIN_SCALE を下回り得るため、下限を個別設定して
      // 「配置後に勝手に拡大される」のを防ぐ。上限は印刷エリアを覆える程度に。
      if (logo.width && logo.height) {
        const cover = Math.max(PRINT_W / logo.width, PRINT_H / logo.height);
        logo.maxScale = cover * 1.5;
      } else {
        logo.maxScale = 3;
      }
      logo.minScale = Math.min(MIN_SCALE, logo.scaleX * 0.3);
      // #669 読み込み中に他の素材が増えて上限に達した場合は追加しない（連続タップ対策）
      if (!canAddMaterial(false)) return;
      canvas.add(logo);
      renderLayerPanel();
      canvas.setActiveObject(logo);
      canvas.requestRenderAll();
      pushHistory(); // #662 ロゴ追加を履歴へ
      console.log('✅ ロゴ（SVG）追加完了');
    }, null, { crossOrigin: 'anonymous' });
  }

  // 単色ロゴの色を変更（グループ内の各パスの塗り／線にまとめて適用）
  function applyLogoColor(logo, color) {
    const parts = (logo._objects && logo._objects.length) ? logo._objects : [logo];
    parts.forEach(p => {
      if (p.fill) p.set('fill', color);
      if (p.stroke) p.set('stroke', color);
      if (!p.fill && !p.stroke) p.set('fill', color);
    });
    logo.dirty = true;
  }

  // =============================
  // 図形パーツ追加
  // =============================
  function addShape(shapeType, shapeName) {
    // #669 上限に達していたら図形も追加しない
    if (!canAddMaterial()) return;

    let shape;
    const common = {
      left: BASE_W / 2,
      top: BASE_H / 2,
      originX: 'center',
      originY: 'center',
      fill: currentShapeColor
    };

    if (shapeType === 'circle') {
      shape = new fabric.Circle(Object.assign({}, common, { radius: 90 }));
    } else if (shapeType === 'triangle') {
      shape = new fabric.Triangle(Object.assign({}, common, { width: 180, height: 180 }));
    } else {
      shape = new fabric.Rect(Object.assign({}, common, { width: 180, height: 180 }));
    }

    shape.materialName = shapeName;
    shape.__layerId = crypto.randomUUID();
    shape.__seq = ++layerSeq;
    shape.__isDesignPart = true;
    shape.__isShape = true;
    shape.shapeType = shapeType;
    shape.maxScale = 3; // 図形は初期scale=1のため上限を大きめに設定
    // #661 背景の四角は、カスタム範囲エディタと同様に辺の中点ハンドルで比率（縦横比）を変更できるようにする。
    // 角＝比率維持、辺の中点＝比率変更。等比強制（object:scaling/modified）からも除外する。
    const allowRatioScale = (shapeType === 'rect');
    shape.__allowRatioScale = allowRatioScale;

    shape.set({
      clipPath: mask,
      cornerStyle: 'circle',
      transparentCorners: false,
      cornerColor: '#999',
      cornerStrokeColor: '#fff',
      borderColor: '#ccc',
      borderOpacityWhenMoving: 0.5,
      cornerSize: 12,
      touchCornerSize: 24,
      hasRotatingPoint: true,
      padding: 0,
      lockScalingFlip: true,
      lockUniScaling: allowRatioScale ? true : false
    });

    shape.setControlsVisibility(allowRatioScale
      ? { mt: true, mb: true, ml: true, mr: true, tl: true, tr: true, bl: true, br: true, mtr: true }
      : { mt: false, mb: false, ml: false, mr: false, tl: true, tr: true, bl: true, br: true, mtr: true }
    );

    canvas.add(shape);
    // カスタムモードでは印刷ウィンドウ（複数の合計）でクリップする
    if (customMode) shape.clipPath = buildCustomClip();
    // 四角は背景として最背面へ（Tシャツ・印刷枠より前、他のデザイン素材より後ろ）
    canvas.sendToBack(shape);
    canvas.sendToBack(printArea);
    const shirtObj = canvas.getObjects().find(o => o.__isTshirt);
    if (shirtObj) canvas.sendToBack(shirtObj);
    renderLayerPanel();
    canvas.setActiveObject(shape);
    canvas.requestRenderAll();
    pushHistory(); // #662 背景（四角）追加を履歴へ

    console.log('✅ 背景（四角）追加完了:', shapeType);
  }

  shapeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      addShape(btn.dataset.shape, btn.dataset.shapeName || '図形');
    });
  });

  // =============================
  // 図形の色選択
  // =============================
  function setShapeColor(color) {
    currentShapeColor = color;
    if (colorToggleSwatch) colorToggleSwatch.style.background = color;
    const active = canvas.getActiveObject();
    if (active && active.__isShape) {
      if (active.__isLogo) applyLogoColor(active, color); // SVGロゴは内部パスへ適用
      else active.set('fill', color);
      canvas.requestRenderAll();
      renderLayerPanel();
    }
  }

  // ロゴ（SVGグループ）の現在色を取得（最初に見つかった塗り／線）
  function getLogoColor(logo) {
    const parts = (logo._objects && logo._objects.length) ? logo._objects : [logo];
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].fill) return parts[i].fill;
      if (parts[i].stroke) return parts[i].stroke;
    }
    return null;
  }

  // 図形選択時のみカラーボタンを表示し、現在色をボタン／パレットに反映
  function updateColorToggle() {
    const active = canvas.getActiveObject();
    const isShape = !!(active && active.__isShape);
    if (colorToggle) colorToggle.style.display = isShape ? 'inline-flex' : 'none';
    // 選択中オブジェクトの実際の色をスウォッチ／ピッカーに反映（ロゴはグループ内パスの色）
    const currentFill = isShape ? (active.__isLogo ? getLogoColor(active) : active.fill) : null;
    if (currentFill) {
      currentShapeColor = currentFill;
      if (colorToggleSwatch) colorToggleSwatch.style.background = currentFill;
      if (colorInput && /^#[0-9a-fA-F]{6}$/.test(currentFill)) colorInput.value = currentFill;
    }
  }

  if (colorInput) {
    // カラーボタン（label）タップでOSのカラーピッカーが開き、選択で図形の色を変更
    colorInput.addEventListener('input', (e) => setShapeColor(e.target.value));
    // #662 色確定時（ピッカーを閉じた等）に1回だけ履歴へ（input中の逐次発火は積まない）
    colorInput.addEventListener('change', () => pushHistory());
  }

  // =============================
  // 範囲エディタ（カスタム専用の別画面）
  //   デフォルト長方形の中に図形（印刷ウィンドウ）を複数配置して印刷範囲を作る。
  //   長方形の外へはみ出して配置してもよいが、はみ出した部分は非表示＝印刷されない。
  // =============================
  // 範囲エディタの寸法（画面サイズに応じて開くたびに再計算する）
  let RANGE_RECT_W = 260;   // 印刷可能な長方形の表示幅(px)
  let RANGE_RECT_H = 332;   // 同・高さ
  let RANGE_MARGIN = 44;    // 長方形の外側（印刷されない余白）
  let RANGE_DISP_W = 348;   // キャンバス全体の表示幅
  let RANGE_DISP_H = 420;   // キャンバス全体の表示高さ
  let RANGE_RECT_LEFT = 44; // 長方形の左上（範囲エディタ座標）
  let RANGE_RECT_TOP = 44;
  let RANGE_F = PRINT_W / RANGE_RECT_W; // 範囲エディタ(長方形内)→メイン座標の倍率

  // 画面の幅・高さに収まるよう、印刷長方形の表示サイズ RANGE_RECT_W を決めて各寸法を再計算する。
  // 横長PC（高さが低い画面）でも上下が切れないようにするための肝。
  function computeRangeDims() {
    const marginRatio = 0.17;                 // 余白＝長方形幅に対する比率
    const rectRatio = PRINT_H / PRINT_W;      // 長方形の高さ/幅
    const dispWFactor = 1 + 2 * marginRatio;  // DISP_W / RECT_W
    const dispHFactor = rectRatio + 2 * marginRatio; // DISP_H / RECT_W
    // タイトル・説明・ボタン群・余白でおよそ 300px 使う想定で、キャンバスに使える高さを算出
    const availH = Math.max(180, window.innerHeight - 300);
    const availW = Math.max(220, Math.min(472, window.innerWidth * 0.9 - 40));
    let rectW = Math.min(260, availW / dispWFactor, availH / dispHFactor);
    rectW = Math.max(150, rectW);
    RANGE_RECT_W = Math.round(rectW);
    RANGE_RECT_H = Math.round(rectW * rectRatio);
    RANGE_MARGIN = Math.round(rectW * marginRatio);
    RANGE_DISP_W = RANGE_RECT_W + RANGE_MARGIN * 2;
    RANGE_DISP_H = RANGE_RECT_H + RANGE_MARGIN * 2;
    RANGE_RECT_LEFT = RANGE_MARGIN;
    RANGE_RECT_TOP = RANGE_MARGIN;
    RANGE_F = PRINT_W / RANGE_RECT_W;
  }

  const rangeCanvasEl = document.getElementById('range-canvas');
  const rangeDeleteBtn = document.getElementById('range-delete');
  const rangeDuplicateBtn = document.getElementById('range-duplicate');
  const rangeCreateBtn = document.getElementById('range-create');
  const rangeBackBtn = document.getElementById('range-back');
  const rangeAddBtns = document.querySelectorAll('.range-add');
  const selectPane = document.querySelector('.print-shape-pane[data-pane="select"]');
  const rangePane = document.querySelector('.print-shape-pane[data-pane="range"]');
  let rangeCanvas = null;

  function showSelectPane() {
    if (selectPane) selectPane.hidden = false;
    if (rangePane) rangePane.hidden = true;
  }
  function showRangePane() {
    if (selectPane) selectPane.hidden = true;
    if (rangePane) rangePane.hidden = false;
  }

  // 印刷可能な長方形（範囲エディタ座標）でクリップする矩形。はみ出しはこれで非表示になる。
  function makeRangeClipRect() {
    return new fabric.Rect({
      left: RANGE_DISP_W / 2, top: RANGE_DISP_H / 2, originX: 'center', originY: 'center',
      width: RANGE_RECT_W, height: RANGE_RECT_H, absolutePositioned: true
    });
  }

  function updateRangeButtons() {
    const shapes = rangeCanvas ? rangeCanvas.getObjects().filter(o => o.__isRegionShape) : [];
    const active = rangeCanvas && rangeCanvas.getActiveObject();
    if (rangeDeleteBtn) rangeDeleteBtn.disabled = !(active && active.__isRegionShape);
    if (rangeDuplicateBtn) rangeDuplicateBtn.disabled = !(active && active.__isRegionShape);
    if (rangeCreateBtn) rangeCreateBtn.disabled = shapes.length === 0;
  }

  // 選択中の印刷ウィンドウを複製（少しずらして配置）
  function duplicateRangeShape() {
    const a = rangeCanvas && rangeCanvas.getActiveObject();
    if (!a || !a.__isRegionShape) return;
    const c = a.getCenterPoint();
    const common = { left: c.x + 20, top: c.y + 20, originX: 'center', originY: 'center' };
    let s;
    if (a.shapeType === 'circle') {
      s = new fabric.Circle(Object.assign({}, common, { radius: a.radius }));
    } else if (a.shapeType === 'triangle') {
      s = new fabric.Triangle(Object.assign({}, common, { width: a.width, height: a.height }));
    } else {
      s = new fabric.Rect(Object.assign({}, common, { width: a.width, height: a.height }));
    }
    s.set({ scaleX: a.scaleX || 1, scaleY: a.scaleY || 1, angle: a.angle || 0 });
    styleRegionShape(s, a.shapeType);
    rangeCanvas.add(s);
    rangeCanvas.setActiveObject(s);
    rangeCanvas.requestRenderAll();
    updateRangeButtons();
  }

  // 範囲エディタの図形（印刷ウィンドウ）の共通スタイル・操作設定
  function styleRegionShape(s, type) {
    s.__isRegionShape = true;
    s.shapeType = type;
    s.maxScale = 5;
    s.set({
      fill: 'rgba(59, 130, 246, 0.14)',
      stroke: '#3b82f6',
      strokeWidth: 2,
      strokeDashArray: [6, 4],
      strokeUniform: true, // 拡大縮小しても枠線・点線の太さを一定にする
      // 長方形からはみ出した部分は非表示（印刷されない）
      clipPath: makeRangeClipRect(),
      cornerStyle: 'circle',
      transparentCorners: false,
      cornerColor: '#3b82f6',
      cornerStrokeColor: '#fff',
      borderColor: '#3b82f6',
      cornerSize: 14,
      touchCornerSize: 28,
      hasRotatingPoint: true,
      padding: 0,
      lockScalingFlip: true,
      // 角（tl/tr/bl/br）は比率維持で拡大縮小、辺の中点（ml/mr/mt/mb）は比率変更で拡大縮小
      lockUniScaling: true
    });
    s.setControlsVisibility({ mt: true, mb: true, ml: true, mr: true, tl: true, tr: true, bl: true, br: true, mtr: true });
  }

  function addRangeShape(type) {
    if (!rangeCanvas) return;
    const common = { left: RANGE_DISP_W / 2, top: RANGE_DISP_H / 2, originX: 'center', originY: 'center' };
    const r = Math.round(RANGE_RECT_W * 0.17);   // 既定の半径（長方形幅に比例）
    const d = Math.round(RANGE_RECT_W * 0.35);   // 既定の一辺（長方形幅に比例）
    let s;
    if (type === 'circle') {
      s = new fabric.Circle(Object.assign({}, common, { radius: r }));
    } else if (type === 'triangle') {
      s = new fabric.Triangle(Object.assign({}, common, { width: d, height: d }));
    } else {
      type = 'rect';
      s = new fabric.Rect(Object.assign({}, common, { width: d, height: d }));
    }
    styleRegionShape(s, type);
    rangeCanvas.add(s);
    rangeCanvas.setActiveObject(s);
    rangeCanvas.requestRenderAll();
    updateRangeButtons();
  }

  // 既存のカスタム窓（メイン座標）を範囲エディタ座標へ戻して復元（再調整用）
  function restoreRangeShapes() {
    if (!rangeCanvas) return;
    const mainLeft = (BASE_W - PRINT_W) / 2;
    const mainTop = (BASE_H - PRINT_H) / 2;
    customWindows.forEach(def => {
      const common = {
        left: RANGE_RECT_LEFT + (def.cx - mainLeft) / RANGE_F,
        top: RANGE_RECT_TOP + (def.cy - mainTop) / RANGE_F,
        originX: 'center', originY: 'center'
      };
      let s;
      if (def.type === 'circle') {
        s = new fabric.Circle(Object.assign({}, common, { radius: (def.radius || 45) / RANGE_F }));
      } else if (def.type === 'triangle') {
        s = new fabric.Triangle(Object.assign({}, common, { width: (def.w || 90) / RANGE_F, height: (def.h || 90) / RANGE_F }));
      } else {
        s = new fabric.Rect(Object.assign({}, common, { width: (def.w || 90) / RANGE_F, height: (def.h || 90) / RANGE_F }));
      }
      s.set({ scaleX: def.scaleX || 1, scaleY: def.scaleY || 1, angle: def.angle || 0 });
      styleRegionShape(s, def.type);
      rangeCanvas.add(s);
    });
  }

  // restore=true かつ既存のカスタム窓があれば、それを復元して開く（再調整）。無ければ初期ウィンドウ1つ。
  function initRangeEditor(restore) {
    if (!rangeCanvasEl) return;
    // 開くたびに画面サイズに合わせて寸法を再計算（横長PCでも収まるように）
    computeRangeDims();
    if (!rangeCanvas) {
      rangeCanvas = new fabric.Canvas(rangeCanvasEl, {
        backgroundColor: '#ededed', // 余白＝印刷されない領域（グレー）
        selection: true,
        preserveObjectStacking: true,
        allowTouchScrolling: false
      });
      rangeCanvas.on('selection:created', updateRangeButtons);
      rangeCanvas.on('selection:updated', updateRangeButtons);
      rangeCanvas.on('selection:cleared', updateRangeButtons);

      // #663 範囲エディタ内スナップ（常時ON）。図形の中心・端を既定長方形の中心・四辺へ吸着。
      // 磁石トグル(snapEnabled)には依存しない＝複雑になりすぎる範囲作成を抑える狙い。
      // ガイドは __isRangeSnapGuide（__isRegionShape ではない）ので確定処理には含まれない。
      const R_SNAP_PX = 8;
      let rGuideV = null, rGuideH = null, rGuideVX = null, rGuideHY = null;
      function rangeRect() {
        return {
          cx: RANGE_DISP_W / 2, cy: RANGE_DISP_H / 2,
          left: RANGE_DISP_W / 2 - RANGE_RECT_W / 2, right: RANGE_DISP_W / 2 + RANGE_RECT_W / 2,
          top: RANGE_DISP_H / 2 - RANGE_RECT_H / 2, bottom: RANGE_DISP_H / 2 + RANGE_RECT_H / 2
        };
      }
      function rGuideStyle() { return { stroke: '#ff3b6b', strokeWidth: 1, strokeDashArray: [5, 4], strokeUniform: true, selectable: false, evented: false, excludeFromExport: true }; }
      function rShowV(x, r) { if (rGuideV && rGuideVX !== x) { rangeCanvas.remove(rGuideV); rGuideV = null; } if (!rGuideV) { rGuideV = new fabric.Line([x, r.top, x, r.bottom], rGuideStyle()); rGuideV.__isRangeSnapGuide = true; rangeCanvas.add(rGuideV); rGuideVX = x; } rangeCanvas.bringToFront(rGuideV); }
      function rHideV() { if (rGuideV) { rangeCanvas.remove(rGuideV); rGuideV = null; rGuideVX = null; } }
      function rShowH(y, r) { if (rGuideH && rGuideHY !== y) { rangeCanvas.remove(rGuideH); rGuideH = null; } if (!rGuideH) { rGuideH = new fabric.Line([r.left, y, r.right, y], rGuideStyle()); rGuideH.__isRangeSnapGuide = true; rangeCanvas.add(rGuideH); rGuideHY = y; } rangeCanvas.bringToFront(rGuideH); }
      function rHideH() { if (rGuideH) { rangeCanvas.remove(rGuideH); rGuideH = null; rGuideHY = null; } }
      function rClearGuides() { if (rGuideV || rGuideH) { rHideV(); rHideH(); rangeCanvas.requestRenderAll(); } }
      function rPick(cands, th) { let best = null; cands.forEach(c => { const d = Math.abs(c.value - c.target); if (d <= th && (!best || d < best.d)) best = { d: d, delta: c.target - c.value, guide: c.target }; }); return best; }

      rangeCanvas.on('object:moving', (e) => {
        const obj = e.target;
        if (!obj || !obj.__isRegionShape) return;
        const th = R_SNAP_PX / (rangeCanvas.getZoom() || 1);
        const r = rangeRect();
        const bb = obj.getBoundingRect(true, true);
        const cx = bb.left + bb.width / 2, cy = bb.top + bb.height / 2;
        const sx = rPick([{ value: cx, target: r.cx }, { value: bb.left, target: r.left }, { value: bb.left + bb.width, target: r.right }], th);
        const sy = rPick([{ value: cy, target: r.cy }, { value: bb.top, target: r.top }, { value: bb.top + bb.height, target: r.bottom }], th);
        if (sx) obj.left += sx.delta;
        if (sy) obj.top += sy.delta;
        if (sx || sy) obj.setCoords();
        if (sx) rShowV(sx.guide, r); else rHideV();
        if (sy) rShowH(sy.guide, r); else rHideH();
      });

      rangeCanvas.on('object:scaling', (e) => {
        const obj = e.target;
        if (!obj || !obj.__isRegionShape) return;
        if ((obj.angle || 0) % 360 !== 0) return;               // 回転中はスキップ
        const corner = e.transform && e.transform.corner;
        if (!corner) return;
        const th = R_SNAP_PX / (rangeCanvas.getZoom() || 1);
        const r = rangeRect();
        const w = obj.width * obj.scaleX, h = obj.height * obj.scaleY;
        const left = obj.left - w / 2, right = obj.left + w / 2, top = obj.top - h / 2, bottom = obj.top + h / 2;
        const movingRight = corner.indexOf('r') !== -1, movingLeft = corner.indexOf('l') !== -1;
        const movingBottom = corner.indexOf('b') !== -1, movingTop = corner.indexOf('t') !== -1;
        const edgeHandle = (corner === 'ml' || corner === 'mr' || corner === 'mt' || corner === 'mb'); // 辺=各軸独立、角=等比
        let sxCand = null, syCand = null;
        if (movingRight && Math.abs(right - r.right) <= th) sxCand = { scale: (r.right - left) / obj.width, guide: r.right, dist: Math.abs(right - r.right) };
        else if (movingLeft && Math.abs(left - r.left) <= th) sxCand = { scale: (right - r.left) / obj.width, guide: r.left, dist: Math.abs(left - r.left) };
        if (movingBottom && Math.abs(bottom - r.bottom) <= th) syCand = { scale: (r.bottom - top) / obj.height, guide: r.bottom, dist: Math.abs(bottom - r.bottom) };
        else if (movingTop && Math.abs(top - r.top) <= th) syCand = { scale: (bottom - r.top) / obj.height, guide: r.top, dist: Math.abs(top - r.top) };
        let useX = false, useY = false;
        if (edgeHandle) {
          if (sxCand && sxCand.scale > 0) { obj.scaleX = sxCand.scale; useX = true; }
          if (syCand && syCand.scale > 0) { obj.scaleY = syCand.scale; useY = true; }
        } else {
          let cand = null;
          if (sxCand && syCand) cand = (sxCand.dist <= syCand.dist) ? { c: sxCand, axis: 'x' } : { c: syCand, axis: 'y' };
          else if (sxCand) cand = { c: sxCand, axis: 'x' };
          else if (syCand) cand = { c: syCand, axis: 'y' };
          if (cand && cand.c.scale > 0) { obj.scaleX = cand.c.scale; obj.scaleY = cand.c.scale; if (cand.axis === 'x') useX = true; else useY = true; }
        }
        if (!useX && !useY) { rHideV(); rHideH(); return; }
        const nw = obj.width * obj.scaleX, nh = obj.height * obj.scaleY;
        if (movingRight) obj.left = left + nw / 2; else if (movingLeft) obj.left = right - nw / 2;
        if (movingBottom) obj.top = top + nh / 2; else if (movingTop) obj.top = bottom - nh / 2;
        obj.setCoords();
        if (useX) rShowV(sxCand.guide, r); else rHideV();
        if (useY) rShowH(syCand.guide, r); else rHideH();
      });

      rangeCanvas.on('object:modified', rClearGuides);
      rangeCanvas.on('mouse:up', rClearGuides);
      rangeCanvas.on('selection:cleared', rClearGuides);
    } else {
      // 既存の中身を全消し（枠も含めて作り直す＝寸法変更に追従）
      rangeCanvas.getObjects().slice().forEach(o => rangeCanvas.remove(o));
      rangeCanvas.discardActiveObject();
    }
    // 現在の寸法でキャンバスサイズを設定
    rangeCanvas.setWidth(RANGE_DISP_W);
    rangeCanvas.setHeight(RANGE_DISP_H);
    // 印刷可能な長方形（白＋点線枠）。ここが印刷される最大範囲。
    const bound = new fabric.Rect({
      left: RANGE_DISP_W / 2, top: RANGE_DISP_H / 2, originX: 'center', originY: 'center',
      width: RANGE_RECT_W, height: RANGE_RECT_H,
      fill: '#ffffff', stroke: '#000', strokeWidth: 2, strokeDashArray: [8, 6],
      selectable: false, evented: false
    });
    rangeCanvas.add(bound);
    // 再調整（restore）時のみ既存ウィンドウを復元。新規は空から開始（初期図形なし）。
    if (restore && customWindows.length) {
      restoreRangeShapes();
    }
    updateRangeButtons();
    rangeCanvas.requestRenderAll();
  }

  rangeAddBtns.forEach(btn => {
    btn.addEventListener('click', () => addRangeShape(btn.dataset.shape));
  });

  if (rangeDuplicateBtn) {
    rangeDuplicateBtn.addEventListener('click', duplicateRangeShape);
  }

  if (rangeDeleteBtn) {
    rangeDeleteBtn.addEventListener('click', () => {
      const active = rangeCanvas && rangeCanvas.getActiveObject();
      if (active && active.__isRegionShape) {
        rangeCanvas.remove(active);
        rangeCanvas.discardActiveObject();
        rangeCanvas.requestRenderAll();
        updateRangeButtons();
      }
    });
  }

  if (rangeBackBtn) {
    rangeBackBtn.addEventListener('click', showSelectPane); // 形の選び直しへ
  }

  if (rangeCreateBtn) {
    rangeCreateBtn.addEventListener('click', () => {
      const shapes = rangeCanvas ? rangeCanvas.getObjects().filter(o => o.__isRegionShape) : [];
      if (!shapes.length) return;
      const mainLeft = (BASE_W - PRINT_W) / 2;
      const mainTop = (BASE_H - PRINT_H) / 2;
      const defs = shapes.map(o => {
        const c = o.getCenterPoint();
        // 範囲エディタ座標 → 長方形内ローカル → メインキャンバス座標
        const def = {
          type: o.shapeType,
          cx: mainLeft + (c.x - RANGE_RECT_LEFT) * RANGE_F,
          cy: mainTop + (c.y - RANGE_RECT_TOP) * RANGE_F,
          angle: o.angle || 0,
          scaleX: o.scaleX || 1,
          scaleY: o.scaleY || 1
        };
        if (o.shapeType === 'circle') def.radius = o.radius * RANGE_F;
        else { def.w = o.width * RANGE_F; def.h = o.height * RANGE_F; }
        return def;
      });
      applyCustomWindows(defs);
      printShapeConfirmed = true;
      if (printShapeModal) printShapeModal.classList.remove('active');
    });
  }

// =============================
// ユーティリティ関数
// =============================
function downloadBlob(blob, filename = 'design.png') {
  try {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    console.log('✅ ダウンロード完了:', filename);
  } catch (error) {
    console.error('❌ ダウンロードエラー:', error);
    throw error;
  }
}

// 店舗マスタデータ
const STORE_MASTER = {
  '001': 'A(R)TTIC',
  '002': 'WEBSHOP'
};

function getStoreIdFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const storeParam = urlParams.get('store');
  
  if (!storeParam) {
    console.log('📍 店舗IDパラメータなし。デフォルト値を使用: 000');
    return '000';
  }
  
  const storeNumber = parseInt(storeParam, 10);
  
  if (isNaN(storeNumber) || storeNumber < 1 || storeNumber > 999) {
    console.warn('⚠️ 無効な店舗ID:', storeParam, '→ デフォルト値を使用: 000');
    return '000';  // 修正箇所
  }
  
  const storeId = String(storeNumber).padStart(3, '0');
  console.log('📍 店舗ID取得:', storeId);
  return storeId;
}

function getStoreName(storeId) {
  return STORE_MASTER[storeId] || '未登録店舗';
}

function displayStoreId() {
  const urlParams = new URLSearchParams(window.location.search);
  const storeParam = urlParams.get('store');
  
  // クエリパラメータがない場合は何も表示しない
  if (!storeParam) {
    console.log('📍 店舗IDパラメータなし。表示をスキップ');
    return '000';
  }
  
  const storeId = getStoreIdFromURL();
  const storeName = getStoreName(storeId);
  const isUnregistered = storeName === '未登録店舗';
  
  const storeInfo = document.createElement('div');
  storeInfo.id = 'store-info';
  
  // 登録済み: 黒、未登録: グレー
  const bgColor = isUnregistered ? '#999999' : '#333';
  
  storeInfo.style.cssText = `
    position: fixed;
    top: 10px;
    right: 10px;
    background: ${bgColor};
    color: white;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 11px;
    z-index: 30;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    line-height: 1.4;
  `;
  
  storeInfo.innerHTML = `
    <div style="font-weight: bold; margin-bottom: 2px;">
      ${storeName}
    </div>
    <div style="font-size: 9px; opacity: 0.8;">
      ID: ${storeId}
    </div>
  `;
  
  document.body.appendChild(storeInfo);
  
  console.log(`📍 店舗情報: ${storeName} (ID: ${storeId})`);
  return storeId;
}

function generateRandomString(length) {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function generateDesignFilename(storeId = '000') {  // デフォルト値も '000' に変更（オプション）
  const now = new Date();
  const timestamp = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
    String(now.getHours()).padStart(2, '0'),
    String(now.getMinutes()).padStart(2, '0'),
    String(now.getSeconds()).padStart(2, '0')
  ].join('');
  
  const random = generateRandomString(6);
  const filename = `tshirt_${timestamp}_${random}_${storeId}.png`;
  
  console.log('📝 生成されたファイル名:', filename);
  return filename;
}

function parseDesignFilename(filename) {
  const match = filename.match(/^tshirt_(\d{14})_([a-z0-9]{6})_(\d{3})\.png$/);
  
  if (!match) {
    console.warn('⚠️ ファイル名の形式が不正:', filename);
    return null;
  }
  
  const [, timestamp, random, storeId] = match;
  
  const year = timestamp.substring(0, 4);
  const month = timestamp.substring(4, 6);
  const day = timestamp.substring(6, 8);
  const hour = timestamp.substring(8, 10);
  const minute = timestamp.substring(10, 12);
  const second = timestamp.substring(12, 14);
  
  const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  
  return {
    filename,
    timestamp,
    random,
    storeId,
    date,
    dateString: date.toLocaleString('ja-JP')
  };
  }

  // =============================
  // 高解像度PNG書き出し機能
  // =============================
  async function exportPrintAreaAsPNG(targetWidth = 3000) {
    const printAreaWidth = PRINT_W;
    const printAreaHeight = PRINT_H;
    const scale = targetWidth / printAreaWidth;
    const outputHeight = Math.round(printAreaHeight * scale);

    // 復元に必要な元状態を try 外スコープで保持（例外時も finally で必ず戻すため）
    const originalVpt = canvas.viewportTransform.slice();
    const originalWidth = canvas.getWidth();
    const originalHeight = canvas.getHeight();
    const prevBg = canvas.backgroundColor;
    const exportShirt = canvas.getObjects().find(o => o.__isTshirt);
    let removedGuides = [];   // 書き出し中に一旦キャンバスから外す印刷ウィンドウ目印
    let uncachedParts = [];   // 書き出し中にキャッシュ無効化するデザインパーツ
    let savedClips = [];      // #660 surgicalマスク中に退避するデザインパーツのclipPath

    try {
      console.log('🖼️ 高解像度PNG書き出し開始');
      console.log(`出力サイズ: ${targetWidth}x${outputHeight}px (scale: ${scale.toFixed(2)})`);

      canvasEl.style.visibility = 'hidden';
      
      // 書き出し中は等倍・panなしに固定（拡大表示中でも印刷結果は同じ）
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      canvas.setWidth(BASE_W);
      canvas.setHeight(BASE_H);
      
      printArea.set({ visible: false });
      // カスタムの印刷ウィンドウ目印（青点線）は、確実に書き出しへ含めないため一旦キャンバスから外す
      // （visible:false だと環境によって薄く出るケースがあったため、除去方式にする）
      removedGuides = canvas.getObjects().filter(o => o.__isRegionGuide || o.__isSnapGuide);
      removedGuides.forEach(o => canvas.remove(o));
      // デザインパーツのキャッシュを一時無効化＝拡大時もクリップ境界を原寸で描き、色のにじみを防ぐ
      uncachedParts = canvas.getObjects().filter(o => o.__isDesignPart);
      uncachedParts.forEach(o => { o.objectCaching = false; o.dirty = true; });

      // #660: カスタム/円/三角の印刷範囲は、fabricのclipPath（destination-in）が境界に
      // アンチエイリアスの半透明の縁を残し、書き出し画像で「境界線に最背面素材の色の線」として写る。
      // そこで素材のclipPathを一旦外して素材本来のalphaのまま描画し、書き出し後に
      // 「二値化した窓マスク」でdestination-inする（境界だけ鮮明化＝素材内部の半透明は保持）。
      // 全体(長方形)はクロップ範囲＝印刷範囲そのものでにじみが出ないため対象外。
      let maskShapes = null;
      if (customMode && customWindows.length) {
        maskShapes = customWindows.map(makeWindowShape);
      } else if (printShapeType === 'circle' || printShapeType === 'triangle') {
        maskShapes = [makePrintShape(printShapeType)];
      }
      if (maskShapes) {
        savedClips = uncachedParts.map(o => o.clipPath);
        uncachedParts.forEach(o => { o.clipPath = null; o.dirty = true; });
      }

      // 背景の白・Tシャツ下地は書き出しに含めない（デザインの無い箇所は透明に）
      canvas.backgroundColor = '';
      if (exportShirt) exportShirt.set({ visible: false });
      canvas.requestRenderAll();

      await new Promise(resolve => setTimeout(resolve, 10));
      
      const cropLeft = (BASE_W - PRINT_W) / 2;
      const cropTop = (BASE_H - PRINT_H) / 2;
      
      console.log('クロップ範囲:', {
        left: cropLeft,
        top: cropTop,
        width: PRINT_W,
        height: PRINT_H
      });
      
      // 生キャンバスを取得（マスク合成のためピクセル操作する）
      const outCanvas = canvas.toCanvasElement(scale, {
        left: cropLeft,
        top: cropTop,
        width: PRINT_W,
        height: PRINT_H
      });

      // #660: 二値化した窓マスクで destination-in し、クリップ境界の色にじみ（線）を消す。
      // マスクは0/255の二値なので、素材本来のalphaは保持しつつ境界だけが鮮明になる。
      if (maskShapes) {
        const maskFab = new fabric.StaticCanvas(null, { width: BASE_W, height: BASE_H, enableRetinaScaling: false });
        maskFab.backgroundColor = '';
        maskShapes.forEach(s => { s.set({ fill: '#000', stroke: null, opacity: 1 }); maskFab.add(s); });
        maskFab.renderAll();
        const maskCanvas = maskFab.toCanvasElement(scale, { left: cropLeft, top: cropTop, width: PRINT_W, height: PRINT_H });
        const mctx = maskCanvas.getContext('2d');
        const mImg = mctx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
        const mData = mImg.data;
        for (let i = 3; i < mData.length; i += 4) mData[i] = mData[i] >= 128 ? 255 : 0;
        mctx.putImageData(mImg, 0, 0);
        const octx = outCanvas.getContext('2d');
        octx.save();
        octx.globalCompositeOperation = 'destination-in';
        octx.drawImage(maskCanvas, 0, 0);
        octx.restore();
        maskFab.dispose();
      }

      const dataURL = outCanvas.toDataURL('image/png');

      const response = await fetch(dataURL);
      if (!response.ok) {
        throw new Error('Blob変換失敗');
      }

      const blob = await response.blob();

      console.log('✅ PNG書き出し完了');
      console.log('ファイルサイズ:', (blob.size / 1024 / 1024).toFixed(2), 'MB');
      console.log('実際の出力サイズ:', `${targetWidth}x${outputHeight}px`);

      return blob;

    } catch (error) {
      console.error('❌ PNG書き出しエラー:', error);
      throw error;
    } finally {
      // 例外の有無にかかわらず、必ず元の表示状態へ復元する
      // （viewport変換・canvasサイズ・背景色・Tシャツ表示・印刷ウィンドウ目印・キャッシュ・可視状態）
      canvas.setViewportTransform(originalVpt);
      canvas.setWidth(originalWidth);
      canvas.setHeight(originalHeight);
      printArea.set({ visible: true });
      removedGuides.forEach(o => { if (canvas.getObjects().indexOf(o) === -1) canvas.add(o); });
      uncachedParts.forEach(o => { o.objectCaching = true; o.dirty = true; });
      // #660 surgicalマスクで一旦外したclipPathを元に戻す
      if (savedClips.length) uncachedParts.forEach((o, i) => { o.clipPath = savedClips[i]; o.dirty = true; });
      canvas.backgroundColor = prevBg;
      if (exportShirt) exportShirt.set({ visible: true });
      canvas.requestRenderAll();
      canvasEl.style.visibility = 'visible';
    }
  }

  // =============================
  // 保存ボタン
  // =============================
  let confirmBtn = document.getElementById('designer-confirm-btn');
  
  if (!confirmBtn) {
    confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.id = 'designer-confirm-btn';
    confirmBtn.className = 'designer-confirm-btn';
    confirmBtn.textContent = 'この内容で決定';
    confirmBtn.style.display = 'none';
    toolbar.appendChild(confirmBtn);
  }

  // 「この内容で決定」押下後の処理は tshirt-kiosk.js（kiosk連携）側で登録する。
  // ここではボタンの参照取得と表示制御のみ行い、クリック挙動（画像生成→BWSアップロード→QR表示）は
  // kiosk 側へ委譲する。ローカルへのPNGダウンロードは行わない（QR表示のみで完結）。

  // =============================
  // タブ切り替え
  // =============================
  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => {
      console.log('タブクリック:', tab.dataset.category);
      
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const category = tab.dataset.category;

      if (category === '__save__') {
        imageBtns.forEach(btn => btn.style.display = 'none');
        shapeBtns.forEach(btn => btn.style.display = 'none');
        confirmBtn.style.display = 'inline-flex';
      } else {
        confirmBtn.style.display = 'none';

        // 「背景」カテゴリのときだけ、背景用の四角ボタンも表示する
        const isBackgroundTab = (category === '背景');
        shapeBtns.forEach(btn => btn.style.display = isBackgroundTab ? 'inline-flex' : 'none');

        let visibleCount = 0;
        imageBtns.forEach(btn => {
          const btnCategory = btn.dataset.category;
          if (btnCategory === category) {
            btn.style.display = 'inline-flex';
            visibleCount++;
          } else {
            btn.style.display = 'none';
          }
        });

        console.log(`カテゴリ "${category}" の画像: ${visibleCount}個`);
      }
    });

    if (idx === 0) {
      // #666 表示解禁前に初期カテゴリフィルタを確定させ、全素材が一瞬並ぶチラつきを防ぐ。
      tab.click();
      initialFilterReady = true;
      // フィルタ確定後にアクティブカテゴリのサムネ読込完了を待ってから解禁する
      waitForInitialThumbnails();
    }
  });

  // =============================
  // 回転スナップ
  // =============================
  canvas.on('object:rotating', (e) => {
    e.target.angle = Math.round(e.target.angle / ROTATION_SNAP) * ROTATION_SNAP;
  });

  // =============================
  // スナップ #663
  // 素材を動かしたとき、中心および端が「印刷範囲の中心・四辺」に近づくと吸着し、ガイド線を表示する。
  // ガイドは __isSnapGuide（デザイン素材ではない）なので、レイヤー/履歴/書き出しの対象外。
  // =============================
  const SNAP_SCREEN_PX = 8;               // 画面上の吸着しきい値（px）
  const SNAP_CX = BASE_W / 2;             // 印刷範囲の中心X(=450)
  const SNAP_CY = BASE_H / 2;             // 印刷範囲の中心Y(=550)
  const SNAP_LEFT = SNAP_CX - PRINT_W / 2, SNAP_RIGHT = SNAP_CX + PRINT_W / 2;   // 枠の左右(275/625)
  const SNAP_TOP = SNAP_CY - PRINT_H / 2, SNAP_BOTTOM = SNAP_CY + PRINT_H / 2;   // 枠の上下(355/745)
  let snapGuideV = null, snapGuideH = null, guideVX = null, guideHY = null;
  let snapEnabled = true;                 // #663 スナップ ON/OFF（既定ON）

  function guideStyle() {
    return { stroke: '#ff3b6b', strokeWidth: 1.5, strokeDashArray: [6, 5], strokeUniform: true, selectable: false, evented: false, excludeFromExport: true };
  }
  // 縦ガイド（吸着したX位置に表示）。位置が変わったら作り直す。
  function showSnapGuideV(x) {
    if (snapGuideV && guideVX !== x) { canvas.remove(snapGuideV); snapGuideV = null; }
    if (!snapGuideV) { snapGuideV = new fabric.Line([x, SNAP_TOP, x, SNAP_BOTTOM], guideStyle()); snapGuideV.__isSnapGuide = true; canvas.add(snapGuideV); guideVX = x; }
    canvas.bringToFront(snapGuideV);
  }
  function hideSnapGuideV() { if (snapGuideV) { canvas.remove(snapGuideV); snapGuideV = null; guideVX = null; } }
  // 横ガイド（吸着したY位置に表示）
  function showSnapGuideH(y) {
    if (snapGuideH && guideHY !== y) { canvas.remove(snapGuideH); snapGuideH = null; }
    if (!snapGuideH) { snapGuideH = new fabric.Line([SNAP_LEFT, y, SNAP_RIGHT, y], guideStyle()); snapGuideH.__isSnapGuide = true; canvas.add(snapGuideH); guideHY = y; }
    canvas.bringToFront(snapGuideH);
  }
  function hideSnapGuideH() { if (snapGuideH) { canvas.remove(snapGuideH); snapGuideH = null; guideHY = null; } }
  function clearSnapGuides() {
    if (snapGuideV || snapGuideH) { hideSnapGuideV(); hideSnapGuideH(); canvas.requestRenderAll(); }
  }

  // 候補（中心/左端/右端 など）から最も近い吸着先を選ぶ
  function pickSnap(cands, threshold) {
    let best = null;
    cands.forEach(c => {
      const d = Math.abs(c.value - c.target);
      if (d <= threshold && (!best || d < best.d)) best = { d: d, delta: c.target - c.value, guide: c.target };
    });
    return best;
  }

  canvas.on('object:moving', (e) => {
    const obj = e.target;
    if (!obj || !obj.__isDesignPart) return;
    if (!snapEnabled) { clearSnapGuides(); return; }        // #663 スナップOFF時は吸着しない
    const threshold = SNAP_SCREEN_PX / (canvas.getZoom() || 1);
    const bb = obj.getBoundingRect(true, true); // BASE座標の外接矩形
    const cx = bb.left + bb.width / 2, cy = bb.top + bb.height / 2;
    // X: 中心 / 左端 / 右端 を印刷枠の 中心・左辺・右辺 に吸着
    const sx = pickSnap([
      { value: cx, target: SNAP_CX },
      { value: bb.left, target: SNAP_LEFT },
      { value: bb.left + bb.width, target: SNAP_RIGHT }
    ], threshold);
    // Y: 中心 / 上端 / 下端 を印刷枠の 中心・上辺・下辺 に吸着
    const sy = pickSnap([
      { value: cy, target: SNAP_CY },
      { value: bb.top, target: SNAP_TOP },
      { value: bb.top + bb.height, target: SNAP_BOTTOM }
    ], threshold);
    // 中心原点なので left/top を delta ぶんずらせば外接矩形ごと平行移動する
    if (sx) obj.left += sx.delta;
    if (sy) obj.top += sy.delta;
    if (sx || sy) obj.setCoords();
    if (sx) showSnapGuideV(sx.guide); else hideSnapGuideV();
    if (sy) showSnapGuideH(sy.guide); else hideSnapGuideH();
  });

  // ドラッグ終了・選択解除・クリックでガイドを消す（ガイドは一時表示のみ）
  canvas.on('object:modified', clearSnapGuides);
  canvas.on('mouse:up', clearSnapGuides);
  canvas.on('selection:cleared', clearSnapGuides);

  // #663 スナップ ON/OFF トグル（磁石ボタン）
  const snapToggleBtn = document.getElementById('designer-snap-toggle');
  if (snapToggleBtn) {
    snapToggleBtn.addEventListener('click', () => {
      snapEnabled = !snapEnabled;
      snapToggleBtn.classList.toggle('is-on', snapEnabled);
      snapToggleBtn.setAttribute('aria-pressed', snapEnabled ? 'true' : 'false');
      if (!snapEnabled) clearSnapGuides(); // OFFにしたら表示中のガイドを消す
    });
  }

  // =============================
  // スケール制限
  // =============================
  canvas.on('object:scaling', (e) => {
    const obj = e.target;
    const objId = obj.cacheKey || obj.id || canvas.getObjects().indexOf(obj);
    
    if (!lastValidScale[objId]) {
      lastValidScale[objId] = {
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        left: obj.left,
        top: obj.top
      };
    }

    // #661 比率変更を許可する素材（背景の四角）は、等比強制せず各軸を独立にクランプする
    if (obj.__allowRatioScale) {
      const maxS = obj.maxScale || MAX_SCALE;
      const minS = obj.minScale || MIN_SCALE;
      let sx = obj.scaleX, sy = obj.scaleY, ok = true;
      if (sx < minS) { sx = minS; ok = false; } else if (sx > maxS) { sx = maxS; ok = false; }
      if (sy < minS) { sy = minS; ok = false; } else if (sy > maxS) { sy = maxS; ok = false; }
      obj.scaleX = sx;
      obj.scaleY = sy;
      if (!ok) {
        obj.left = lastValidScale[objId].left;
        obj.top = lastValidScale[objId].top;
        obj.setCoords();
      } else {
        lastValidScale[objId] = { scaleX: sx, scaleY: sy, left: obj.left, top: obj.top };
      }
      return;
    }

    let newScale = Math.max(obj.scaleX, obj.scaleY);
    let isValid = true;

    const maxScale = obj.maxScale || MAX_SCALE;
    const minScale = obj.minScale || MIN_SCALE;
    if (newScale < minScale) {
      newScale = minScale;
      isValid = false;
    }
    if (newScale > maxScale) {
      newScale = maxScale;
      isValid = false;
    }
    
    if (!isValid) {
      obj.scaleX = newScale;
      obj.scaleY = newScale;
      obj.left = lastValidScale[objId].left;
      obj.top = lastValidScale[objId].top;
      obj.setCoords();
    } else {
      obj.scaleX = newScale;
      obj.scaleY = newScale;
      lastValidScale[objId] = {
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        left: obj.left,
        top: obj.top
      };
    }
  });

  // #663 拡大スナップ：上のスケール制限が確定したあと、掴んでいるハンドルの「動く辺」が
  // 印刷枠の辺に近ければ、対辺（アンカー）を固定したまま枠にぴったり吸着させる。
  // 既存挙動は変えず、枠の辺の近く（しきい値内）でのみ働く。回転中・min/max超過時はスキップ。
  canvas.on('object:scaling', (e) => {
    const obj = e.target;
    if (!obj || !obj.__isDesignPart) return;
    if (!snapEnabled) { hideSnapGuideV(); hideSnapGuideH(); return; } // #663 スナップOFF時は吸着しない
    if ((obj.angle || 0) % 360 !== 0) return;               // 回転中は軸非整列のためスキップ
    const corner = e.transform && e.transform.corner;
    if (!corner) return;

    const objId = obj.cacheKey || obj.id || canvas.getObjects().indexOf(obj);
    const threshold = SNAP_SCREEN_PX / (canvas.getZoom() || 1);
    const minScale = obj.minScale || MIN_SCALE;
    const maxScale = obj.maxScale || MAX_SCALE;
    const ratio = !!obj.__allowRatioScale;                  // 背景四角=各軸独立／それ以外=等比

    // 現在の外接矩形（angle0前提）
    const w = obj.width * obj.scaleX, h = obj.height * obj.scaleY;
    const left = obj.left - w / 2, right = obj.left + w / 2;
    const top = obj.top - h / 2, bottom = obj.top + h / 2;

    // 掴んでいるハンドルから「動く辺」を判定
    const movingRight = corner.indexOf('r') !== -1;   // tr,br,mr
    const movingLeft = corner.indexOf('l') !== -1;    // tl,bl,ml
    const movingBottom = corner.indexOf('b') !== -1;  // bl,br,mb
    const movingTop = corner.indexOf('t') !== -1;     // tl,tr,mt

    // 動く辺が枠の辺に近いか（近い方の候補スケールを求める）
    let sxCand = null, syCand = null;
    if (movingRight && Math.abs(right - SNAP_RIGHT) <= threshold) sxCand = { scale: (SNAP_RIGHT - left) / obj.width, guide: SNAP_RIGHT, dist: Math.abs(right - SNAP_RIGHT) };
    else if (movingLeft && Math.abs(left - SNAP_LEFT) <= threshold) sxCand = { scale: (right - SNAP_LEFT) / obj.width, guide: SNAP_LEFT, dist: Math.abs(left - SNAP_LEFT) };
    if (movingBottom && Math.abs(bottom - SNAP_BOTTOM) <= threshold) syCand = { scale: (SNAP_BOTTOM - top) / obj.height, guide: SNAP_BOTTOM, dist: Math.abs(bottom - SNAP_BOTTOM) };
    else if (movingTop && Math.abs(top - SNAP_TOP) <= threshold) syCand = { scale: (bottom - SNAP_TOP) / obj.height, guide: SNAP_TOP, dist: Math.abs(top - SNAP_TOP) };

    let useX = false, useY = false;
    if (ratio) {
      // 各軸独立に吸着（範囲内のみ）
      if (sxCand && sxCand.scale >= minScale && sxCand.scale <= maxScale) { obj.scaleX = sxCand.scale; useX = true; }
      if (syCand && syCand.scale >= minScale && syCand.scale <= maxScale) { obj.scaleY = syCand.scale; useY = true; }
    } else {
      // 等比：近い方の辺に合わせて両軸同じスケール
      let cand = null;
      if (sxCand && syCand) cand = (sxCand.dist <= syCand.dist) ? { c: sxCand, axis: 'x' } : { c: syCand, axis: 'y' };
      else if (sxCand) cand = { c: sxCand, axis: 'x' };
      else if (syCand) cand = { c: syCand, axis: 'y' };
      if (cand && cand.c.scale >= minScale && cand.c.scale <= maxScale) {
        obj.scaleX = cand.c.scale; obj.scaleY = cand.c.scale;
        if (cand.axis === 'x') useX = true; else useY = true;
      }
    }

    if (!useX && !useY) { hideSnapGuideV(); hideSnapGuideH(); return; }

    // アンカー（動かない辺）を固定して再配置
    const nw = obj.width * obj.scaleX, nh = obj.height * obj.scaleY;
    if (movingRight) obj.left = left + nw / 2;
    else if (movingLeft) obj.left = right - nw / 2;
    if (movingBottom) obj.top = top + nh / 2;
    else if (movingTop) obj.top = bottom - nh / 2;
    obj.setCoords();
    lastValidScale[objId] = { scaleX: obj.scaleX, scaleY: obj.scaleY, left: obj.left, top: obj.top };

    if (useX) showSnapGuideV(sxCand.guide); else hideSnapGuideV();
    if (useY) showSnapGuideH(syCand.guide); else hideSnapGuideH();
  });

  canvas.on('object:modified', (e) => {
    const obj = e.target;
    console.log('================');
  console.log('scaleX', obj.scaleX);
  console.log('scaleY', obj.scaleY);
  console.log('width', obj.width);
  console.log('height', obj.height);
  console.log('scaledWidth', obj.getScaledWidth());
  console.log('scaledHeight', obj.getScaledHeight());
    const objId = obj.cacheKey || obj.id || canvas.getObjects().indexOf(obj);

    // #661 比率変更を許可する素材（背景の四角）は、等比強制せず各軸を独立にクランプする
    if (obj.__allowRatioScale) {
      const maxS = obj.maxScale || MAX_SCALE;
      const minS = obj.minScale || MIN_SCALE;
      obj.scaleX = Math.min(maxS, Math.max(minS, obj.scaleX));
      obj.scaleY = Math.min(maxS, Math.max(minS, obj.scaleY));
      obj.setCoords();
      canvas.requestRenderAll();
      lastValidScale[objId] = { scaleX: obj.scaleX, scaleY: obj.scaleY, left: obj.left, top: obj.top };
      return;
    }

    let finalScale = Math.max(obj.scaleX, obj.scaleY);

    const maxScale = obj.maxScale || MAX_SCALE;
    const minScale = obj.minScale || MIN_SCALE;
    if (finalScale < minScale) {
      finalScale = minScale;
    }
    if (finalScale > maxScale) {
      finalScale = maxScale;
    }

    obj.scaleX = finalScale;
    obj.scaleY = finalScale;
    obj.setCoords();
    canvas.requestRenderAll();

    lastValidScale[objId] = {
      scaleX: obj.scaleX,
      scaleY: obj.scaleY,
      left: obj.left,
      top: obj.top
    };

    console.log('最終スケール:', obj.scaleX.toFixed(2));
  });

  canvas.on('object:removed', (e) => {
    const obj = e.target;
    const objId = obj.cacheKey || obj.id || canvas.getObjects().indexOf(obj);
    delete lastValidScale[objId];
  });

  // =============================
  // タッチデバイス最適化
  // =============================
  canvasEl.addEventListener('touchstart', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });

  let lastTap = 0;
  canvasEl.addEventListener('touchend', (e) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;
    
    if (tapLength < 300 && tapLength > 0) {
      e.preventDefault();
    }
    
    lastTap = currentTime;
  });

  // =============================
  // キーボードショートカット
  // =============================
  document.addEventListener('keydown', (e) => {
    const obj = canvas.getActiveObject();
    if (!obj || obj === printArea) return;

    const step = e.shiftKey ? 10 : 1;

    switch(e.key) {
      case 'Delete':
      case 'Backspace':
        e.preventDefault();
        canvas.remove(obj);
        canvas.discardActiveObject();
        canvas.requestRenderAll();
        break;
      case 'ArrowUp':
        e.preventDefault();
        obj.top -= step;
        canvas.requestRenderAll();
        break;
      case 'ArrowDown':
        e.preventDefault();
        obj.top += step;
        canvas.requestRenderAll();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        obj.left -= step;
        canvas.requestRenderAll();
        break;
      case 'ArrowRight':
        e.preventDefault();
        obj.left += step;
        canvas.requestRenderAll();
        break;
    }
  });

  // =============================
  // 戻る/進む（undo/redo） #662
  // =============================
  const undoBtn = document.getElementById('designer-undo');
  const redoBtn = document.getElementById('designer-redo');

  // 現在のデザイン素材（Tシャツ・印刷枠・ガイドは除く）を取得
  function historyDesignParts() {
    return canvas.getObjects().filter(o => o !== printArea && o.__isDesignPart);
  }

  // 現在の状態をスナップショット（オブジェクト参照＋復元に必要な値のみ）
  function captureState() {
    return historyDesignParts().map(o => ({
      obj: o,
      left: o.left, top: o.top,
      scaleX: o.scaleX, scaleY: o.scaleY,
      angle: o.angle, flipX: o.flipX, flipY: o.flipY,
      fill: (o.__isShape && !o.__isLogo) ? o.fill : null,
      logoColor: o.__isLogo ? getLogoColor(o) : null,
      lockMovementX: o.lockMovementX, lockMovementY: o.lockMovementY,
      lockRotation: o.lockRotation, lockScalingX: o.lockScalingX, lockScalingY: o.lockScalingY,
      selectable: o.selectable, evented: o.evented, hasControls: o.hasControls
    }));
  }

  function updateHistoryButtons() {
    if (undoBtn) undoBtn.disabled = !(histIndex > 0);
    if (redoBtn) redoBtn.disabled = !(histIndex < history.length - 1);
  }

  // 操作完了後に呼び、現在状態を履歴へ積む（復元中は無視）
  function pushHistory() {
    if (restoring) return;
    history = history.slice(0, histIndex + 1); // redo側を破棄
    history.push(captureState());
    if (history.length > HISTORY_MAX) history.shift();
    histIndex = history.length - 1;
    updateHistoryButtons();
  }

  // スナップショットへ復元。デザイン素材のみを対象にし、Tシャツ・印刷枠・クリップ・印刷範囲には触れない。
  function restoreState(state) {
    restoring = true;
    try {
      canvas.discardActiveObject();
      const wanted = new Set(state.map(e => e.obj));
      // 現在あって snapshot に無い素材は外す（参照は保持されるので破棄はしない＝redoで戻せる）
      historyDesignParts().forEach(o => { if (!wanted.has(o)) canvas.remove(o); });
      // snapshot の各素材を復元＋キャンバスに存在させる
      state.forEach(e => {
        const o = e.obj;
        if (canvas.getObjects().indexOf(o) === -1) canvas.add(o);
        o.set({
          left: e.left, top: e.top, scaleX: e.scaleX, scaleY: e.scaleY,
          angle: e.angle, flipX: e.flipX, flipY: e.flipY,
          lockMovementX: e.lockMovementX, lockMovementY: e.lockMovementY,
          lockRotation: e.lockRotation, lockScalingX: e.lockScalingX, lockScalingY: e.lockScalingY,
          selectable: e.selectable, evented: e.evented, hasControls: e.hasControls
        });
        if (e.fill != null) o.set('fill', e.fill);
        if (e.logoColor != null) applyLogoColor(o, e.logoColor);
        // #663 印刷範囲は履歴対象外のため、復元素材のclipPathが古い形のままだと現在の印刷範囲とズレる
        // （削除→印刷範囲変更→undoで復活 のケース）。常に現在の印刷範囲のクリップを再適用する。
        o.clipPath = customMode ? buildCustomClip() : mask;
        o.dirty = true;
        o.setCoords();
      });
      // 並び順を復元（背面→前面へ bringToFront）。デザイン素材のみ動かし、Tシャツ/印刷枠は背面のまま。
      state.forEach(e => canvas.bringToFront(e.obj));
      canvas.requestRenderAll();
      renderLayerPanel();
    } finally {
      restoring = false;
    }
    updateHistoryButtons();
  }

  function undo() {
    if (histIndex > 0) { histIndex--; restoreState(history[histIndex]); }
  }
  function redo() {
    if (histIndex < history.length - 1) { histIndex++; restoreState(history[histIndex]); }
  }

  if (undoBtn) undoBtn.addEventListener('click', undo);
  if (redoBtn) redoBtn.addEventListener('click', redo);

  // 移動・拡大縮小・回転の確定時（プログラム的な set では発火しない＝復元と競合しない）
  canvas.on('object:modified', pushHistory);

  // 初期状態（素材なし）を履歴の先頭として記録
  pushHistory();

  // =============================
  // 初期化完了
  // =============================
  displayStoreId();

  window.__TSHIRT_DESIGNER__ = {
    canvas, 
    printArea, 
    mask,
    BASE_W,
    BASE_H,
    PRINT_W,
    PRINT_H,
    exportPrintAreaAsPNG,
    setPrintShape,
    showPrintShapeModalOnce,
    showConfirmDialog,
    undo,
    redo,
    downloadBlob,
    generateDesignFilename,
    parseDesignFilename,
    generateRandomString,
    getStoreIdFromURL,
    displayStoreId
  };

  console.log('✅ Tシャツデザイナー初期化完了');
  console.log('タブ数:', tabs.length);
  console.log('画像ボタン数:', imageBtns.length);
  // 表示解禁（revealDesigner / maybeReveal）は初期化の冒頭で定義済み。
  // SVG読込完了(svgReady)・初期カテゴリフィルタ完了(initialFilterReady)が揃うと表示する（#666）。
});
